import { useMediaQuery, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

import { useCurrentPage } from '»utils/customHooks';

import StandardBgLoginPage from '../../../assets/img/STANDARD_bg-login.webp';
import StandardBgLPageSM from '../../../assets/img/STANDARD_bg-lpage-sm.webp';
import { GradientContainer, TextContainer } from '../AppCard.styles';
import {
  BackgroundMobileImageStyled,
  BoxBackgroundImageStyled,
  CardContainer,
  LandingPageText,
} from './AppCardStandard.styles';

export const AppCardStandard = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const location = useLocation();

  const { isNoAuthFormPage, isLoginPage, isOnboardingAdvancedSteps } =
    useCurrentPage(location.pathname);

  if (isDesktop)
    return (
      <BoxBackgroundImageStyled
        isFormPage={isNoAuthFormPage}
        isLoginPage={isLoginPage}
        isOnboardingAdvancedSteps={isOnboardingAdvancedSteps}
      >
        <GradientContainer
          isOnboardingAdvancedSteps={isOnboardingAdvancedSteps}
        >
          <TextContainer isFormPage={isNoAuthFormPage}>
            <LandingPageText isFormPage={isNoAuthFormPage}>
              <FormattedMessage id="TRLT_UI-LANDING_PAGE_SLOGAN_STANDARD" />
            </LandingPageText>
          </TextContainer>
        </GradientContainer>
      </BoxBackgroundImageStyled>
    );

  return (
    <CardContainer isFormPage={isNoAuthFormPage}>
      <LandingPageText isFormPage={isNoAuthFormPage}>
        <FormattedMessage id="TRLT_UI-LANDING_PAGE_SLOGAN_STANDARD" />
      </LandingPageText>
      <BackgroundMobileImageStyled
        alt="background-mobile-image"
        component="img"
        src={isLoginPage ? StandardBgLoginPage : StandardBgLPageSM}
        isFormPage={isNoAuthFormPage}
      />
    </CardContainer>
  );
};
